import React, { Component } from "react";
import { connect } from "react-redux";

//Redux
import { history } from "../store";

//Actions
import * as ACTIONS from "./../actions/actionConstants";

//Components
import ToolBar from "./ToolBar";
import InfoSnackbar from "./../components/InfoSnackbar";

//Deps
import classNames from "classnames";
import { push } from "react-router-redux";

//MUI
import { LinearProgress, MuiThemeProvider, withTheme } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";
import * as THEME from "./../styles/themes";

//Routes
import AccountRouter from "./../pages/AccountRouter";
import DashboardRouter from "./../pages/DashboardRouter";
import LogsRouter from "./../pages/LogsRouter";

//Pages
import LoginPage from "./../pages/LoginPage";
import ProductsPage from "./../pages/ProductsPage";
import ProfilePage from "./../pages/ProfilePage";
import SignUpPage from "./../pages/SignUpPage";

//Router
import { ConnectedRouter } from "connected-react-router";
import { Route } from "react-router";

//Utilities
import { checkDeviceOnResize } from "./../util/watchScreenWidth";

//Styles
import "./../styles/index.css";

function mapStateToProps(state) {
  return {
    authUser: state.user.auth,
    cUID: state.user.currentUser.client,
    darkMode: state.app.darkMode,
    deviceType: state.app.deviceType,
    email: state.user.currentUser.profile.email,
    isMobile: state.app.deviceType === "mobile",
    role: state.user.currentUser.role,
    route: state.router.location ? state.router.location.pathname : null,

    //Menu
    anchorEl: state.menu.anchorEl,

    //Snackbar
    isOpen: state.snackbar.isOpen,
    message: state.snackbar.message,
    variant: state.snackbar.variant,

    //Auth State
    isAdmin: state.user.currentUser.admin,
    isAnon: state.user.auth ? state.user.auth.isAnonymous : null,
    isAuth: state.user.auth ? true : false,
    isAuthenticated: state.user.isAuthenticated,
    userDataFetched: state.user.currentUser.userDataFetched,

    //Form pending
    loginPending: state.forms.forms.login.$form.pending,
    logoutPending: state.forms.forms.logout.$form.pending,
    signUpPending: state.forms.forms.signUp.$form.pending,
    signUpSubmitted: state.forms.forms.signUp.$form.submitted
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    closeSnackbar: () => {
      dispatch({ type: ACTIONS.CLOSE_SNACKBAR });
    },
    deviceTypeDispatch: device =>
      dispatch({ type: ACTIONS.CHECK_DEVICE, payload: device }),
    handleClose: path =>
      dispatch({ type: ACTIONS.HIT_MENU, meta: { path, close: true } }),
    handleMenu: e =>
      dispatch({ type: ACTIONS.OPEN_MENU, payload: e.currentTarget }),
    init: () => dispatch({ type: ACTIONS.INIT, dispatch }),
    routeToHome: auth => {
      auth ? dispatch(push("/dashboard")) : dispatch(push("/"));
    },
    routeToLogin: () => {
      dispatch(push("login"));
    },
    routeToSignUp: () => {
      dispatch(push("signup"));
    },
    submitLogout: (cUID, email) => {
      dispatch({
        type: ACTIONS.SUBMIT_LOGOUT,
        cUID,
        email
      });
    }
  };
}

class App extends Component {
  componentWillMount() {
    const { deviceType, deviceTypeDispatch, init } = this.props;
    // eslint-disable-next-line
    deviceType === null ? init() : null;

    //Events
    checkDeviceOnResize(deviceTypeDispatch);
  }

  themeHandler(darkMode, role) {
    let theme;

    if (role === "client") {
      if (darkMode) {
        theme = { ...THEME.clientDark };
      } else {
        theme = { ...THEME.clientLight };
      }
    } else if (role === "user") {
      if (darkMode) {
        theme = { ...THEME.userDark };
      } else {
        theme = { ...THEME.userLight };
      }
    } else {
      theme = { ...THEME.defaultTheme };
    }

    return theme;
  }

  componentWillReceiveProps(nextProps) {
    const { isAuth, routeToHome } = this.props;
    if (isAuth !== nextProps.isAuth) {
      routeToHome(nextProps.isAuth);
    }
  }

  render() {
    const {
      darkMode,
      isOpen,
      loginPending,
      message,
      role,
      signUpPending,
      variant
    } = this.props;

    //Classes
    const appRoute = classNames({
      appRoute: true
    });

    const theme = this.themeHandler(darkMode, role);

    return (
      <MuiThemeProvider theme={theme}>
        <CssBaseline />
        <div className="App">
          <InfoSnackbar
            message={message}
            type={variant}
            isOpen={isOpen}
            {...this.props}
          />
          <ToolBar {...this.props} />
          {loginPending || signUpPending ? <LinearProgress /> : null}
          <ConnectedRouter history={history}>
            <div className={appRoute}>
              <Route exact path="/" component={ProductsPage} />
              <Route exact path="/account" component={AccountRouter} />
              <Route exact path="/dashboard" component={DashboardRouter} />
              <Route exact path="/logs" component={LogsRouter} />
              <Route exact path="/login" component={LoginPage} />
              <Route exact path="/products" component={ProductsPage} />
              <Route exact path="/profile" component={ProfilePage} />
              <Route exact path="/signup" component={SignUpPage} />
            </div>
          </ConnectedRouter>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTheme()(App));



// WEBPACK FOOTER //
// ./src/components/App.js